import { useEffect, useRef } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

export function useHeartbeat() {
  const { token, logout } = useAuth();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!token) return;

    const sendHeartbeat = async () => {
      try {
        await api.post('/api/heartbeat');
      } catch (err) {
        if (err.response?.status === 401 && err.response?.data?.detail === 'Session terminated by admin') {
          logout();
          window.location.href = '/login?kicked=1';
        }
      }
    };

    // Send immediately on mount
    sendHeartbeat();

    // Then every 30 seconds
    intervalRef.current = setInterval(sendHeartbeat, 30000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [token, logout]);
}
